import { Breakpoint } from "@relode/core";
import * as React from "react";

import { MemberUpcomingInterview } from "../_infra/types";
import { UpcomingInterviewsDesktop } from "./upcomingInterviewsDesktop";
import { UpcomingInterviewsMobile } from "./upcomingInterviewsMobile";

export const UpcomingInterviews = (props: {
    data: MemberUpcomingInterview[];
}) => {
    const { data } = props;

    if (!data) return null;

    return (
        <>
            <Breakpoint mobile>
                <UpcomingInterviewsMobile data={data} />
            </Breakpoint>
            <Breakpoint desktop>
                <UpcomingInterviewsDesktop data={data} />
            </Breakpoint>
        </>
    );
};
